import type { Locale } from '../i18n'

/**
 * The ten tidal stream atlases, as they are shipped under public/stroom.
 *
 * Each is thirteen plates, HW−6 to HW+6 at one reference harbour. The harbour is not a
 * choice we make: it is printed on the plates themselves ("Referred to HW Harlingen",
 * "Borkum HW"), and it is the only thing that ties the pictures to a clock.
 */
export interface Atlas {
  id: string
  /** Proper nouns travel; the generic half of the name does not */
  name: Record<Locale, string>
  /** Our station id for the harbour the plates are referred to */
  station: string
}

export const ATLASES: Atlas[] = [
  { id: 'wad-west', station: 'harlingen.waddenzee', name: { nl: 'Waddenzee west', en: 'Wadden Sea west', de: 'Wattenmeer West' } },
  // the plates say "Referred to HW Delfzijl"; the old app pointed this atlas at Lauwersoog
  { id: 'wad-oost', station: 'delfzijl', name: { nl: 'Waddenzee oost', en: 'Wadden Sea east', de: 'Wattenmeer Ost' } },
  { id: 'noordzee', station: 'hoekvanholland', name: { nl: 'Noordzee zuid', en: 'North Sea south', de: 'Nordsee Süd' } },
  { id: 'rivieren', station: 'hoekvanholland', name: { nl: 'Benedenrivieren', en: 'Tidal rivers', de: 'Tideflüsse' } },
  { id: 'schelde-oost', station: 'vlissingen', name: { nl: 'Schelde oost', en: 'Scheldt east', de: 'Schelde Ost' } },
  { id: 'schelde-west', station: 'vlissingen', name: { nl: 'Schelde west', en: 'Scheldt west', de: 'Schelde West' } },
  { id: 'duitse-bocht', station: 'DE__509A', name: { nl: 'Duitse Bocht', en: 'German Bight', de: 'Deutsche Bucht' } },
  { id: 'halligen', station: 'DE__510P', name: { nl: 'Halligen', en: 'Halligen', de: 'Halligen' } },
  { id: 'dld-wad-west', station: 'DE__101P', name: { nl: 'Duitse Wadden west', en: 'German Wadden west', de: 'Wattenmeer West (DE)' } },
  { id: 'dld-wad-oost', station: 'DE__101P', name: { nl: 'Duitse Wadden oost', en: 'German Wadden east', de: 'Wattenmeer Ost (DE)' } },
]

export function atlasById(id: string | null): Atlas | undefined {
  return ATLASES.find(a => a.id === id)
}

/** The atlas a place is most likely to want: the one drawn around its own tide station */
export function atlasForStation(station: string | null): Atlas | undefined {
  return station ? ATLASES.find(a => a.station === station) : undefined
}
